import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type GrantedUsersFetchFailedAction = {
	type: 'GRANTED_USERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): GrantedUsersFetchFailedAction => ({
	type: 'GRANTED_USERS_FETCH_FAILED',
	payload,
});
